const LINES = {
  US: { name: "988 Lifeline", number: "988", display: "988", sms: "988" },
  CA: { name: "988 Crisis Line", number: "988", display: "988", sms: "988" },
  GB: { name: "Samaritans", number: "116123", display: "116 123", sms: "85258" },
  IE: { name: "Samaritans", number: "116123", display: "116 123", sms: "50808" },
  AU: { name: "Lifeline", number: "131114", display: "13 11 14", sms: "0477131114" },
  NZ: { name: "Need to Talk", number: "1737", display: "1737", sms: "1737" },
  IN: { name: "Tele-MANAS", number: "14416", display: "14416" },
  ZA: { name: "SADAG", number: "0800567567", display: "0800 567 567", sms: "31393" },
};
const FALLBACK = { name: "Emergency services", number: "112", display: "112" };

export function defaultCrisisLine() {
  const region = (navigator.language || "").split("-")[1]?.toUpperCase() ?? "";
  return LINES[region] ?? FALLBACK;
}

export const telUrl = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;
export const smsUrl = (phone, body) => `sms:${phone.replace(/[^\d+]/g, "")}${body ? `?&body=${encodeURIComponent(body)}` : ""}`;
export const DEFAULT_CALM_MESSAGE =
  "Hi {name}, I've just been through a hard moment and I'm feeling a bit steadier now. Can you talk?";
export const calmMessage = (c) => (c.message || DEFAULT_CALM_MESSAGE).replace("{name}", c.name);

export const GROUNDING_TOOLS = ["5-4-3-2-1 grounding", "Box breathing"];
